import * as React from "react";

import ListCoreUserContainer from "../../containers/CoreUsers/ListCoreUserContainer";

export const CoreUserListScene: React.FC = (): JSX.Element => (
  <div>
    <ListCoreUserContainer />
  </div>
);
